const EntityPermission = {

    // FIELDS
    "employee": "Empleyado",
    "entity_type": "Uri ng Entidad",
    "entity_code": "Kode ng Entidad",
    "search": "Maghanap",

    // PAGE HEADER
    "entity_permission": "Pahintulot ng Entidad",

    // ERROR
    "error_employee": "Piliin ang Empleyado",
    "error_entity_type": "Piliin ang Uri ng Entidad",
    "error_entity_code": "Piliin ang Kode ng Entidad",

    // TABLE HEADER
    "table_employee": "PANGALAN NG EMPLEYADO",
    "table_entity_type": "URI NG ENTIDAD",
    "table_entity_code": "KODE NG ENTIDAD",

}

export default EntityPermission;